import { auth } from "auth"
import { exists } from "utils"
import { graphql, graphqlRequest } from "../graphql"
import { pickLocale } from "./pickLocale"

const query = graphql(`
  query PickLocale {
    currentCompany {
      defaultLocale
      portalSupportedLocales
    }

    currentUser {
      portalLocale
    }
  }
`)

export const pickLocaleForCurrentCompany = async () => {
  const session = await auth.getActiveSession()

  const data = await graphqlRequest({ query, variables: {} })

  const { currentCompany, currentUser } = data
  const { portalLocale } = currentUser
  const { portalSupportedLocales, defaultLocale } = currentCompany
  const allowedLocales = portalSupportedLocales
  const browserLocales = window.navigator.languages
  const sessionLocale = session.pickedLocale

  // First we check if user specifically selected a locale on login screen
  if (isLocaleValid(sessionLocale, allowedLocales)) {
    return sessionLocale
  }

  // If they didn't, we will use user's preferred locale that might
  // have been defined earlier
  if (isLocaleValid(portalLocale, allowedLocales)) {
    return portalLocale
  }

  // If user never defined preferred locale, we will try to use company's
  // default locale, and if this also does not exist, we will get the first
  // from the list of allowed locales
  return pickLocale({
    defaultLocale,
    allowedLocales,
    browserLocales,
  })
}

const isLocaleValid = (
  locale: string | undefined | null,
  allowedLocales: string[]
): locale is string => {
  return exists(locale) && allowedLocales.includes(locale)
}
